/**
 * Feb 2026 · Godown-Category badge — RM/WIP/FG chip used across every
 * inventory surface (Bin Transfer, Godown Balances, Stock Register).
 * Colour palette mirrors the Stock Register tab bar so the pool the
 * user is looking at is always instantly identifiable.
 */
import React from "react";

const KIND_STYLES = {
  RM:  "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  WIP: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  FG:  "bg-sky-500/15 text-sky-300 border-sky-500/30",
};

export default function KindBadge({ kind }) {
  const k = String(kind || "").toUpperCase();
  const cls = KIND_STYLES[k] || "bg-zinc-500/15 text-zinc-300 border-zinc-500/30";
  return (
    <span
      data-testid={`kind-badge-${k || "unknown"}`}
      className={`inline-flex items-center px-1.5 py-0.5 rounded-sm border text-[9px] font-mono uppercase tracking-widest ${cls}`}
    >
      {k || "—"}
    </span>
  );
}
